/**
 * Lien « Vider le panier » (tiroir et page panier).
 * Sans JavaScript, le lien /cart/clear vide le panier et renvoie vers /cart.
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-cart-clear]');
  if (!link) return;
  event.preventDefault();
  if (!window.confirm('Vider votre panier ?')) return;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const drawer = link.closest('cart-drawer');

  fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } })
    .then(() => {
      if (!drawer || typeof drawer.renderContents !== 'function') {
        location.reload();
        return;
      }
      return fetch(`${root}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => response.json())
        .then((sections) => {
          drawer.renderContents({ id: null, sections });
          drawer.classList.add('is-empty');
        });
    })
    .catch(() => location.reload());
});
